/**
 * StorageTemplateModule
 */
export enum StorageTemplateModule {
    NEWS = 'news',
    FEEDBACK = 'feedback',
    KNOWLEDGEBASE = 'knowledgebase',
    COMMUNITIES = 'communities',
    WORKFLOW = 'workflow',
    TV = 'tv'
}
